"use client";
import React, { SetStateAction, useState, useRef, useEffect } from "react";
import _ from "lodash";
import axios from "axios";
import Carousel from "react-material-ui-carousel";
import ReactDOM from "react-dom";
import LanguageDetect from "languagedetect";

import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Stack,
  Alert,
  AlertTitle,
  Checkbox,
  Button,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
} from "@mui/material";

import useOnScreen from "../../hooks/useOnScreen";

import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import FolderIcon from "@mui/icons-material/Folder";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import { getSkinTypeValue } from "../../data/skin-types";
import { cleanAnswer } from "../../data/tags";
import { subscribe } from "../../services/subscription";
import "./questions.css";
import { brandingColors } from "../../components/utils";

export default function Questions(): JSX.Element {
  const urlParams = new URLSearchParams(window.location.search);
  let question = urlParams.get("q") || "skincare";
  let tag = urlParams.get("tag") || "skincare?";
  let t = urlParams.get("t") || "skincare";
  

  const [categorisation, setCategorisation] = useState(false);
  const [email, setEmail] = useState("");

  const lngDetector = new LanguageDetect();

  const detectedLang = lngDetector.detect(question, 3);

  const lang1 = _.head(detectedLang[0]);
  const lang2 = _.head(detectedLang[1]);
  const lang3 = _.head(detectedLang[2]);

  const ref = useRef();

  const regex = /\b(?:doctor|specialist|surgeon|dermatologist|surgeon|doc)\b/gi;

  const isNegativeRegex =
    /\b(?:avoid|refrain from|steer clear of|keep away from|bypass|dodge|duck|eschew\shun)\b/gi;


  const negWords = question.match(isNegativeRegex) || []

  let newQuestion = question
  for (const neg of negWords) {
    newQuestion = _.replace(newQuestion, neg, 'use');
  }

  const isMedical = question.match(regex);

  const [message, setMessage] = useState("");

  const handleChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setMessage(event.target.value);

    console.log("value is:", event.target.value);
  };
  const [open, setOpenState] = useState(false);

  const [errorMsg, setErrorMsg] = useState("");

  const [male, setMale] = useState(false);
  const toggleMale = () => {
    setMale(!male);
    setErrorMsg("");
  };

  const [female, setFemale] = useState(false);
  const toggleFemale = () => {
    setFemale(!female);
    setErrorMsg("");
  };

  /*const [lifeStyleA, setLifestylea] = useState(false);
  const toggleLifestylea = () => {
    setLifestylea(!lifeStyleA);
    setErrorMsg("");
  };

  const [lifeStyleB, setLifestyleb] = useState(false);
  const toggleLifestyleb = () => {
    setLifestyleb(!lifeStyleB);
    setErrorMsg("");
  };

  const [lifeStyleC, setLifestylec] = useState(false);
  const toggleLifestylec = () => {
    setLifestylec(!lifeStyleC);
    setErrorMsg("");
  };

  const [lifeStyleD, setLifestyled] = useState(false);
  const toggleLifestyled = () => {
    setLifestyled(!lifeStyleD);
    setErrorMsg("");
  };

  const [lifeStyleE, setLifestylee] = useState(false);
  const toggleLifestylee = () => {
    setLifestylee(!lifeStyleE);
    setErrorMsg("");
  };

  const [lifeStyleF, setLifestylef] = useState(false);
  const toggleLifestylef = () => {
    setLifestylef(!lifeStyleF);
    setErrorMsg("");
  };*/

  const [agea, setAgea] = useState(false);
  const toggleAgea = () => {
    setAgea(!agea);
    setErrorMsg("");
  };

  const [ageb, setAgeb] = useState(false);
  const toggleAgeb = () => {
    setAgeb(!ageb);
    setErrorMsg("");
  };

  const [agec, setAgec] = useState(false);
  const toggleAgec = () => {
    setAgec(!agec);
    setErrorMsg("");
  };

  const [aged, setAged] = useState(false);
  const toggleAged = () => {
    setAged(!aged);
    setErrorMsg("");
  };

  const [agee, setAgee] = useState(false);
  const toggleAgee = () => {
    setAgee(!agee);
    setErrorMsg("");
  };

  const [skin1, setSkin1] = useState(false);
  const toggleSkin1 = () => {
    setSkin1(!skin1);
    setErrorMsg("");
  };

  const [skin2, setSkin2] = useState(false);
  const toggleSkin2 = () => {
    setSkin2(!skin2);
    setErrorMsg("");
  };

  const [skin3, setSkin3] = useState(false);
  const toggleSkin3 = () => {
    setSkin3(!skin3);
    setErrorMsg("");
  };

  const [skin4, setSkin4] = useState(false);
  const toggleSkin4 = () => {
    setSkin4(!skin4);
    setErrorMsg("");
  };

  //const [scented, setScented] = useState<boolean | null>(null);
  /*const scentedOn = () => {
    setScented(true);
    setErrorMsg("");
  };
  const scentedOff = () => {
    setScented(false);
    setErrorMsg("");
  };*/
  const [sensitive, setSensitive] = useState<boolean | null>(null);
  const sensitiveOn = () => {
    setSensitive(true);
    setErrorMsg("");
  };
  const sensitiveOff = () => {
    setSensitive(false);
    setErrorMsg("");
  };

  const getParams = () => {
    //const scented_ = scented;
    const sensitive_ = sensitive;
    let gender = 0;
    if (male || female) {
      if (male && female) gender = 1;
      if (female && !male) gender = 3;
      if (male && !female) gender = 2;
    }
    const skinType = [];
    if (skin1 || skin2 || skin3 || skin4) {
      if (skin1) skinType.push("1");
      if (skin2) skinType.push("2");
      if (skin3) skinType.push("3");
      if (skin4) skinType.push("4");
    }
    let ageGroup = [];
    if (agea || ageb || agec || aged || agee) {
      if (agea) ageGroup.push("A");
      if (ageb) ageGroup.push("B");
      if (agec) ageGroup.push("C");
      if (aged) ageGroup.push("D");
      if (agee) ageGroup.push("E");
    }
    return {
      //scented: scented_,
      sensitive: sensitive_,
      gender,
      ageGroup,
      skinType,
    };
  };

  const inputStyle = {
    padding: "10px",
    // background: "white",
    // borderRadius: "10px",
    // border: "1px solid #435078",
  };

  const ageGroupRef = useRef<HTMLDivElement>(null);
  const isAgeGroupVisible = useOnScreen(ageGroupRef);

  const lifeStylRef = useRef<HTMLDivElement>(null);
  const isLifeStyleVisible = useOnScreen(lifeStylRef);

  const genderRef = useRef<HTMLDivElement>(null);
  const isGenderVisible = useOnScreen(genderRef);

  const skinRef = useRef<HTMLDivElement>(null);
  const isSkinVisible = useOnScreen(skinRef);

  const sensitiveRef = useRef<HTMLDivElement>(null);
  const isSensitiveVisible = useOnScreen(sensitiveRef);

  const scentRef = useRef<HTMLDivElement>(null);
  const isScentVisible = useOnScreen(scentRef);

  const handleSubmit = async (skinType: string[]) => {
    let skinTypeFilter = '';
    if (skinType.length === 1) {
      skinTypeFilter = 'the skin type is ' + getSkinTypeValue(skinType[0]);
    } else {
      let skinTypeValues: any[] = [];
      skinType.forEach(st => skinTypeValues.push(getSkinTypeValue(st)));
      skinTypeFilter = 'the skin types are ' + _.join(skinTypeValues, ' or ');
    }

    let sensitiveFilter = '';
    if (sensitive !== null && sensitive) {
      sensitiveFilter = 'user has a sensitive skin'
    }

    let filters = skinTypeFilter;
    if (sensitiveFilter !== '') {
      filters = filters + ', ' + sensitiveFilter
    }
    
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    };
    const data = {
      "question": question,
      "filters": filters
    };
    return await axios
      .post("https://asj3q2765lfhvoenr6jh5ctgc40qntfq.lambda-url.eu-west-1.on.aws/", data, {
        headers
      })
      .catch((e) => console.log(e));
  }

  const handleEmailChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setEmail(event.target.value);
  };

  return (
    <Box
      ref={ref}
      sx={{
        width: "100%",
        maxWidth: "1000px",
        color: brandingColors["grey-font"],
        margin: "0 auto",
      }}
    >
      {/* top */}
      <AppBar
        position="static"
        sx={{
          color: brandingColors["grey-font"],
          background: "white",
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            sx={{
              display: "flex",
              flexDirection: { xs: "row", md: "row" },
              justifyContent: "space-between",
              padding: 0,
            }}
          >
            <Box
              sx={{
                padding: 0,
              }}
            >
              <a href="/">
                {" "}
                <img
                  alt=""
                  src="/assets/123skincare_new.png"
                  height="70px"
                  style={{ objectFit: "cover" }}
                />
              </a>
            </Box>

            <Box
              sx={{
                padding: "10px 20px",
                display: {
                  xs: "none",
                  sm: "flex",
                },
                flexDirection: { xs: "row", md: "row" },
                justifyContent: "space-between",
              }}
            >
              {/* <Box
                sx={{
                  padding: "10px 0 10px 15px",
                }}
              >
                <a href="/about">About us</a>
              </Box>
              <Box
                sx={{
                  padding: "10px 0 10px 15px",
                }}
              >
                <a href="/about#work-with-us">Work With us</a>
              </Box> */}
            </Box>
            {/* <Box
              sx={{
                padding: "10px 20px",
                display: {
                  xs: "none",
                  sm: "flex",
                },
                flexDirection: { xs: "row", md: "row" },
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  padding: "10px 15px",
                }}
              >
                <img
                  alt=""
                  src="/assets/uk.png"
                  width="18px"
                  style={{ objectFit: "cover" }}
                />{" "}
              </Box>
              <Box
                sx={{
                  padding: "10px 15px",
                }}
              >
                <Typography variant={"subtitle2"}>Eng</Typography>
              </Box>
              <Box
                sx={{
                  padding: "10px 15px",
                }}
              >
                <img
                  alt=""
                  src="/assets/shopping_cart.svg"
                  width="18px"
                  style={{ objectFit: "cover" }}
                />{" "}
              </Box>
            </Box> */}

            <MenuIcon
              onClick={() => setOpenState(true)}
              sx={{
                mr: 2,
                display: {
                  xs: "block",
                  sm: "none",
                },
              }}
            />

            {/* The outside of the drawer */}
            <Drawer
              //from which side the drawer slides in
              anchor="right"
              //if open is true --> drawer is shown
              open={open}
              //function that is called when the drawer should close
              onClose={() => setOpenState(false)}
            >
              {/* The inside of the drawer */}
              <Box
                sx={{
                  p: 2,
                  height: 1,
                  backgroundColor: brandingColors["grey-background"],
                }}
              >
                {/* when clicking the icon it calls the function toggleDrawer and closes the drawer by setting the variable open to false */}
                <IconButton sx={{ mb: 2 }}>
                  <CloseIcon onClick={() => setOpenState(false)} />
                </IconButton>

                <Divider sx={{ mb: 2 }} />

                <Box sx={{ mb: 2 }}>
                  <ListItemButton>
                    <a href="/about">
                      <ListItemText primary="About Us" />
                    </a>
                  </ListItemButton>

                  <ListItemButton>
                    <a href="/about#work-with-us">
                      <ListItemText primary="Work with us" />
                    </a>
                  </ListItemButton>
                </Box>
              </Box>
            </Drawer>
          </Toolbar>
        </Container>
      </AppBar>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "row", md: "row" },
          justifyContent: "space-between",
          color: brandingColors["grey-font"],
          padding: "20px",
        }}
      >
        <Box
          sx={{
            width: { xs: "0%", sm: "15%" },
            display: { xs: "none", sm: "flex" },
            flexDirection: "column",
            borderRadius: "10px",
            justifyContent: "space-between",
            padding: "100px 30px",
            position: "fixed",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "300px",
              display: "flex",
              flexDirection: { xs: "column", sm: "column" },
              justifyContent: "space-around",
              background: "#f4f6f9",
            }}
          >
            <Box
              sx={{
                padding: "10px",
                fontWeight:
                  agea || ageb || agec || aged || agee ? "900" : "300",
                // fontWeight: isAgeGroupVisible ? "900" : "300",
              }}
            >
              Age Group
            </Box>
            {/*<Box
              sx={{
                padding: "10px",
                fontWeight:
                  lifeStyleA ||
                  lifeStyleB ||
                  lifeStyleC ||
                  lifeStyleD ||
                  lifeStyleE ||
                  lifeStyleF
                    ? "900"
                    : "300",
                // fontWeight: isLifeStyleVisible ? "900" : "300",
              }}
            >
              Life Style
            </Box>*/}
            <Box
              sx={{
                padding: "10px",
                fontWeight: male || female ? "900" : "300",
                // fontWeight: isGenderVisible ? "900" : "300",
              }}
            >
              Gender
            </Box>
            <Box
              sx={{
                padding: "10px",
                fontWeight: skin1 || skin2 || skin3 || skin4 ? "900" : "300",
                // fontWeight: isSkinVisible ? "900" : "300",
              }}
            >
              Skin Type
            </Box>
            <Box
              sx={{
                padding: "10px",
                fontWeight: !_.isNull(sensitive) ? "900" : "300",
                // fontWeight: isSensitiveVisible ? "900" : "300",
              }}
            >
              Sensitive Skin?
            </Box>
            {/*<Box
              sx={{
                padding: "10px",
                fontWeight: !_.isNull(scented) ? "900" : "300",
                // fontWeight: isScentVisible ? "900" : "300",
              }}
            >
              Scented Products?
            </Box>*/}
          </Box>
        </Box>

        {/* centre */}
        <Box
          sx={{
            width: { xs: "100%", sm: "70%" },
            display: "flex",
            flexDirection: "column",
            background: "#f4f6f9",
            borderRadius: "10px",
            justifyContent: "space-between",
            marginLeft: { xs: "0%", sm: "30%" },
          }}
        >
          {/*<Box
            sx={{
              padding: "20px",
            }}
          >
            <Typography variant={"caption"}>
              "
              {question ||
                "We are looking to find skincare products that are suitable for you"}
              "
            </Typography>
            <Typography variant={"caption"}>
              "You are looking for product relating to: {tag || "skincare?"}"
            </Typography>
            <Typography variant={"h5"}>
              In order to help you in a better way, I'd like to know more about
              you.
            </Typography>
              </Box>*/}

          <Box
            sx={{
              margin: "10px 12px",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <Typography className="filter-label"
              variant={"subtitle2"}
              sx={{
                margin: "20px 0",
              }}
              ref={ageGroupRef}
            >
              Age Group
            </Typography>
            <Box className="filter-options"
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-around",
              }}
            >
              <Box sx={inputStyle}>
                <Checkbox checked={agea} onChange={toggleAgea} name="male" /> 15
                - 20
              </Box>
              <Box sx={inputStyle}>
                <Checkbox checked={ageb} onChange={toggleAgeb} name="female" />{" "}
                21 - 25
              </Box>
              <Box sx={inputStyle}>
                <Checkbox checked={agec} onChange={toggleAgec} name="male" /> 26
                - 35
              </Box>
              <Box sx={inputStyle}>
                <Checkbox checked={aged} onChange={toggleAged} name="female" />{" "}
                36 - 50
              </Box>
              <Box sx={inputStyle}>
                <Checkbox checked={agee} onChange={toggleAgee} name="male" />{" "}
                50+
              </Box>
            </Box>
          </Box>

          {/*<Box
            sx={{
              margin: "10px 12px",
              padding: "20px",
              background: "#f4f6f9",
              borderRadius: "10px",
            }}
            ref={lifeStylRef}
          >
            <Typography
              variant={"subtitle2"}
              sx={{
                margin: "20px 0",
              }}
            >
              Life Style
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", sm: "column" },
                justifyContent: "space-around",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "row", sm: "row" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    padding: "20px 0",
                    width: "30%",
                  }}
                >
                  <img
                    alt=""
                    src="/assets/lifestyle1.png"
                    width="100%"
                    style={{ objectFit: "cover", maxWidth: "150px" }}
                  />
                </Box>
                <Box
                  sx={{
                    padding: "10px",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant={"subtitle2"}
                    sx={{
                      marginBottom: "20px",
                      color: brandingColors["red"],
                    }}
                  >
                    MULTITASKER
                  </Typography>
                  <Typography
                    variant={"caption"}
                    sx={{
                      marginBottom: "20px",
                    }}
                  >
                    Individuals who manage responsibilities or work, family and
                    a busy daily life
                  </Typography>
                </Box>
                <Checkbox
                  checked={lifeStyleA}
                  onChange={toggleLifestylea}
                  name="male"
                />
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "row", sm: "row" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    padding: "20px 0",
                    width: "30%",
                  }}
                >
                  <img
                    alt=""
                    src="/assets/lifestyle2.png"
                    width="100%"
                    style={{ objectFit: "cover", maxWidth: "150px" }}
                  />
                </Box>
                <Box
                  sx={{
                    padding: "10px",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant={"subtitle2"}
                    sx={{
                      marginBottom: "20px",
                      color: brandingColors["red"],
                    }}
                  >
                    FREQUENT TRAVELLER
                  </Typography>
                  <Typography
                    variant={"caption"}
                    sx={{
                      marginBottom: "20px",
                    }}
                  >
                    Individuals whose lifestylr ivolves regular travel for work
                    or leisure
                  </Typography>
                </Box>
                <Checkbox
                  checked={lifeStyleB}
                  onChange={toggleLifestyleb}
                  name="male"
                />
              </Box>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "row", sm: "row" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    padding: "20px 0",
                    width: "30%",
                  }}
                >
                  <img
                    alt=""
                    src="/assets/lifestyle3.png"
                    width="100%"
                    style={{ objectFit: "cover", maxWidth: "150px" }}
                  />
                </Box>
                <Box
                  sx={{
                    padding: "10px",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant={"subtitle2"}
                    sx={{
                      marginBottom: "20px",
                      color: brandingColors["red"],
                    }}
                  >
                    OUTDOORMAN
                  </Typography>
                  <Typography
                    variant={"caption"}
                    sx={{
                      marginBottom: "20px",
                    }}
                  >
                    Individuals who have a weekly or serval time monthly for
                    outdoor activities and adventure.
                  </Typography>
                </Box>
                <Checkbox
                  checked={lifeStyleC}
                  onChange={toggleLifestylec}
                  name="male"
                />
              </Box>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "row", sm: "row" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    padding: "20px 0",
                    width: "30%",
                  }}
                >
                  <img
                    alt=""
                    src="/assets/lifestyle4.png"
                    width="100%"
                    style={{ objectFit: "cover", maxWidth: "150px" }}
                  />
                </Box>
                <Box
                  sx={{
                    padding: "10px",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant={"subtitle2"}
                    sx={{
                      marginBottom: "20px",
                      color: brandingColors["red"],
                    }}
                  >
                    BEAUTYPHILE
                  </Typography>
                  <Typography
                    variant={"caption"}
                    sx={{
                      marginBottom: "20px",
                    }}
                  >
                    Person is likely to be enthusiastic about skincare, makeup,
                    hair care, and other aspects of personal grooming and
                    appearance.
                  </Typography>
                </Box>
                <Checkbox
                  checked={lifeStyleD}
                  onChange={toggleLifestyled}
                  name="male"
                />
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "row", sm: "row" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    padding: "20px 0",
                    width: "30%",
                  }}
                >
                  <img
                    alt=""
                    src="/assets/lifestyle5.png"
                    width="100%"
                    style={{ objectFit: "cover", maxWidth: "150px" }}
                  />
                </Box>
                <Box
                  sx={{
                    padding: "10px",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant={"subtitle2"}
                    sx={{
                      marginBottom: "20px",
                      color: brandingColors["red"],
                    }}
                  >
                    SELF-CARE COMMUNITY
                  </Typography>
                  <Typography
                    variant={"caption"}
                    sx={{
                      marginBottom: "20px",
                    }}
                  >
                    Individual who prioritizes their physical and mental health,
                    practice to improve one's health, reduce stress, and enhance
                    overall quality of life.
                  </Typography>
                </Box>
                <Checkbox
                  checked={lifeStyleE}
                  onChange={toggleLifestylee}
                  name="male"
                />
              </Box>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "row", sm: "row" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    padding: "20px 0",
                    width: "30%",
                  }}
                >
                  <img
                    alt=""
                    src="/assets/lifestyle6.png"
                    width="100%"
                    style={{ objectFit: "cover", maxWidth: "150px" }}
                  />
                </Box>
                <Box
                  sx={{
                    padding: "10px",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant={"subtitle2"}
                    sx={{
                      marginBottom: "20px",
                      color: brandingColors["red"],
                    }}
                  >
                    NIGHTLIFR ENTHUSIAST
                  </Typography>
                  <Typography
                    variant={"caption"}
                    sx={{
                      marginBottom: "20px",
                    }}
                  >
                    Maecenas convallis in enim nec eleifend.
                  </Typography>
                </Box>
                <Checkbox
                  checked={lifeStyleF}
                  onChange={toggleLifestylef}
                  name="male"
                />
              </Box>
            </Box>
                  </Box>*/}

          <Box
            sx={{
              margin: "10px 12px",
              padding: "20px",
              background: "#f4f6f9",
              borderRadius: "10px",
            }}
            ref={genderRef}
          >
            <Typography className="filter-label"
              variant={"subtitle2"}
              sx={{
                margin: "20px 0",
              }}
            >
              Gender
            </Typography>
            <Box className="filter-options"
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-around",
              }}
            >
              <Box sx={inputStyle}>
                <Checkbox checked={male} onChange={toggleMale} name="male" />{" "}
                Male
              </Box>
              <Box sx={inputStyle}>
                <Checkbox
                  checked={female}
                  onChange={toggleFemale}
                  name="female"
                />{" "}
                Female
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              margin: "10px 12px",
              padding: "20px",
              borderRadius: "10px",
            }}
            ref={skinRef}
          >
            <Typography className="filter-label"
              variant={"subtitle2"}
              sx={{
                margin: "20px 0",
              }}
            >
              Skin Type
            </Typography>
            <Box className="filter-options"
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-around",
              }}
            >
              <Box sx={inputStyle}>
                <Checkbox checked={skin1} onChange={toggleSkin1} name="male" />{" "}
                Oily
              </Box>
              <Box sx={inputStyle}>
                <Checkbox
                  checked={skin2}
                  onChange={toggleSkin2}
                  name="female"
                />{" "}
                Combination-Oily
              </Box>
              <Box sx={inputStyle}>
                <Checkbox checked={skin3} onChange={toggleSkin3} name="male" />{" "}
                Combination-Dry
              </Box>
              <Box sx={inputStyle}>
                <Checkbox
                  checked={skin4}
                  onChange={toggleSkin4}
                  name="female"
                />{" "}
                Dry
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              margin: "10px 12px",
              padding: "20px",
              background: "#f4f6f9",
              borderRadius: "10px",
            }}
            ref={sensitiveRef}
          >
            <Typography className="filter-label"
              variant={"subtitle2"}
              sx={{
                margin: "20px 0",
              }}
            >
              Do you have sensitive skin?
            </Typography>
            <Box className="filter-options"
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-around",
              }}
            >
              <Box sx={inputStyle}>
                <Checkbox
                  checked={sensitive === true}
                  onChange={sensitiveOn}
                  name="male"
                />{" "}
                Yes
              </Box>
              <Box sx={inputStyle}>
                <Checkbox
                  checked={sensitive === false}
                  onChange={sensitiveOff}
                  name="male"
                />{" "}
                No
              </Box>
            </Box>
          </Box>

          {/*<Box
            sx={{
              margin: "10px 12px",
              padding: "20px",
              borderRadius: "10px",
            }}
            ref={scentRef}
          >
            <Typography
              variant={"subtitle2"}
              sx={{
                margin: "20px 0",
              }}
            >
              Are you open to fragrance in your skincare?
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-around",
              }}
            >
              <Box>
                <Checkbox
                  checked={scented === true}
                  onChange={scentedOn}
                  name="male"
                />{" "}
                Yes
              </Box>
              <Box>
                <Checkbox
                  checked={scented === false}
                  onChange={scentedOff}
                  name="male"
                />{" "}
                No
              </Box>
            </Box>
            </Box>*/}

          <Box className="subscription"
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
          <Box
            sx={{
              margin: "10px 12px",
              padding: "20px",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "70%" },
                display: "flex",
                flexDirection: { xs: "row", md: "row" },
                justifyContent: "space-between",
                color: brandingColors["grey-font"],
                background: "#ff6b73",
                borderRadius: "10px",
                marginX: "auto",
              }}
            >
              {/* <Typography
                variant={"subtitle2"}
                style={{
                  marginRight: "15px",
                  color: "white",
                }}
              >
                Get 15% off your next order, subscribe to our newsletter
              </Typography> */}
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    padding: "10px 20px",
                    width: { xs: "100%", md: "100%" },
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: { xs: "row", md: "row" },
                  }}
                >
                  <TextField
                    id="input-with-sx"
                    label="Enter your email"
                    variant="standard"
                    fullWidth
                    value={email}
                    onChange={handleEmailChange}
                    sx={{
                      display: { xs: "flex", sm: "flex" },
                      color: "white",
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: { xs: "column", md: "column" },
              justifyContent: "space-around",
            }}
          >
            <Button className="btn-go"
              variant="contained"
              sx={{
                color: "white !important",
                background: "#ff6b73 !important",
                margin: "20px auto",
              }}
              onClick={() => {
                const params = getParams();
                const { gender, ageGroup, skinType } = params;
                if (
                  gender === 0 ||
                  _.isEmpty(ageGroup) ||
                  _.isEmpty(skinType)
                ) {
                  console.log("please answer all questions");
                  setErrorMsg("please answer all questions");
                  return;
                }
                if (!_.isEmpty(email)) {
                  subscribe(email, '', '');
                }
                handleSubmit(skinType).then((res) => {
                  if (res) {
                    const resContent = res.data;
                    const cleanedAnswer = cleanAnswer(resContent);
                    window.sessionStorage.setItem("aiAnswer", cleanedAnswer);
                    window.location.href = "/solutions?q=" +
                    encodeURI(question || "") +
                    "&filters=" +
                    encodeURI(JSON.stringify(params))
                    + "&answer=" + btoa(cleanedAnswer);
                  }
                } );
                
              }}
            >
              Go!
            </Button>
            {errorMsg !== "" && (
              <Typography
                variant={"subtitle2"}
                sx={{
                  margin: "0px auto 20px auto",
                  color: "red",
                }}
              >
                {errorMsg}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
      {/* footer */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            margin: "10px 12px",
            padding: "20px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: { xs: "row", md: "row" },
              justifyContent: "space-between",
              color: brandingColors["grey-font"],
            }}
          >
            <Box
              sx={{
                padding: "10px 20px",
                width: "50%",
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "row", md: "row" },
                  justifyContent: "flex-start",
                  color: brandingColors["grey-font"],
                }}
              >
                <a
                  href="https://www.tiktok.com/@123skincarepro"
                  target="_blank"
                >
                  <img
                    alt=""
                    src="/assets/tiktok.svg"
                    width="18px"
                    style={{ objectFit: "cover", marginRight: "5px" }}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/123skincare/"
                  target="_blank"
                >
                  <img
                    alt=""
                    src="/assets/linkedin.svg"
                    width="18px"
                    style={{ objectFit: "cover", marginRight: "5px" }}
                  />
                </a>
                <a
                      href="https://www.instagram.com/123skincare.pro/"
                      target="_blank"
                    >
                      <img
                        alt=""
                        src="/assets/instagram-square.svg"
                        width="18px"
                        style={{ objectFit: "cover", marginRight: "5px" }}
                      />
                    </a>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "10px 20px",
                width: "50%",
                borderRadius: "10px",
              }}
            >
              <Box>
                <Typography variant={"subtitle2"}>
                  We are the first AI-powered beauty recommandation platform
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
